import * as React from "react";
import PropTypes from 'prop-types';

const SvgMouse = props => {
  if (props.id !== "_svgmouse") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 48 48" {...props}><g fill="none" fillRule="evenodd"><path d="M0 0h48v48H0z" /><path fill="#006C7C" d="M28.875 19.297l-3.425 3.385-3.426-3.385a.662.662 0 00-.928 0 .643.643 0 000 .917l3.426 3.385-3.426 3.385a.643.643 0 000 .917.658.658 0 00.928 0l7.78-7.687a.643.643 0 000-.917.662.662 0 00-.929 0zm6.788 3.229a7.838 7.838 0 010 11.165A8.015 8.015 0 0130.013 36a8.015 8.015 0 01-5.65-2.309l-5.6-5.534a6.4 6.4 0 010-9.116l.573-.566-3.544-3.501a2.367 2.367 0 00-3.315 0 2.287 2.287 0 00-.686 1.637c0 .62.244 1.2.686 1.638l1.886 1.864a3.568 3.568 0 011.071 2.554 3.57 3.57 0 01-1.07 2.555 3.692 3.692 0 01-5.172 0 .643.643 0 010-.917.662.662 0 01.928 0 2.367 2.367 0 003.315 0 2.286 2.286 0 00.687-1.638c0-.618-.244-1.2-.687-1.638l-1.886-1.863a3.568 3.568 0 01-1.07-2.555c0-.965.38-1.872 1.07-2.555a3.692 3.692 0 015.172 0l3.543 3.502.573-.567c2.544-2.513 6.682-2.513 9.226 0l5.6 5.535z" /></g></svg>;
};

SvgMouse.displayName = "_svgmouse";
SvgMouse.propTypes = {
  id: PropTypes.string
};
SvgMouse.defaultProps = {
  id: ''
};
export default SvgMouse;